import {InitializationState} from "../types";
import {Reducer} from "redux";
import {initialize, addDevice} from "../routines";

export const initializationState: InitializationState = {
  initialized: false,
  processing: false
};

const initialization: Reducer<InitializationState> = (state: InitializationState = initializationState, action) => {
  switch (action.type) {
    case initialize.FULFILL:
      return {
        ...state,
        initialized: true,
      };

    case addDevice.TRIGGER:
      return {
        ...state,
        processing: true
      }

    case addDevice.SUCCESS:
    case addDevice.FAILURE:
      return {
        ...state,
        processing: false
      }

    default:
      return state;
  }
};

export default initialization;
